export default __webpack_public_path__ + "static/media/logo.f9166cc5.png";